import Axios from 'axios';
import { UI_URL } from './endpoint';

const instance = Axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    "Accept": "application/json, text/plain, */*",
    "Authorization": "Bearer",
    "Referer": UI_URL,
  },
  withCredentials: true,
});

instance.interceptors.request.use(
  async (config) => {
    try {
      config.headers.Authorization = `Bearer `;
      return config;
    } catch (error) {
      console.error('Error token:', error);
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default instance;